import { AppBar, Box, Container, Grid, Toolbar, Typography } from '@mui/material';
import logo from './../assets/logoBanco.png';
import line from './../assets/line.png';

const textAlignStyles = {
  textAlign: {
    xs: 'center',  // Extra-small screens
    sm: 'left',    // Small screens
    md: 'left'     // Medium screens and up
  }
};

const logoStyles = {
  width: {
    xs: 90,   // Extra-small screens
    sm: 120,   // Small screens
    md: 180,   // Medium screens
    lg: 180,   // Large screens
    xl: 180    // Extra-large screens
  },
  height: {
    xs: 22,    // Extra-small screens
    sm: 28,    // Small screens
    md: 46,    // Medium screens
    lg: 46,    // Large screens
    xl: 46     // Extra-large screens
  },
  backgroundImage: `url(${logo})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover'
};

const textoNegrita = {
  fontFamily: 'Montserrat',
  color: '#133385',
  fontWeight: 700,
  lineHeight: '43.88px',
  textAlign: 'left',
  textUnderlinePosition: 'from-font',
  textDecorationSkipInk: 'none',
  fontSize: {
    xs: '3vw',   // Extra-small screens
    sm: '2.5vw',   // Small screens
    md: '2.25vw',   // Medium screens
    lg: '2vw',   // Large screens
    xl: '1.75vw'    // Extra-large screens
  }
};

export function NavBar() {
  return (
    <Box>
      {/* Línea de colores en la parte superior */}
      <Box
        component="img"
        src={line}
        alt="Línea de colores"
        sx={{
          width: '100%',
          height: '9px',
          display: 'block',
        }}
      />
      
      {/* AppBar */}
      <AppBar position="relative" color="transparent" elevation={0}>
        <Toolbar>
          <Container maxWidth="xl">
            <Grid container direction="row" justifyContent="flex-start" alignItems="center">
              <Grid item xs={4} md={3} lg={2} sx={textAlignStyles}>
                <Box mr={2} sx={logoStyles}/>
              </Grid>

              <Grid item xs={8} md={9} lg={10} sx={textAlignStyles}>
                <Typography sx={textoNegrita}>
                  Solicita tu Tarjeta de Crédito
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
